import { useRef, useState, useEffect } from "react";

/**
 * Drag-and-drop before/after slider.
 * Props: before (url), after (url), captionBefore, captionAfter, testId
 */
export default function BeforeAfterSlider({ before, after, captionBefore = "Before", captionAfter = "After", testId = "before-after" }) {
  const containerRef = useRef(null);
  const [pos, setPos] = useState(50); // 0-100 %
  const dragRef = useRef(false);

  const update = (clientX) => {
    const el = containerRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const p = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.max(0, Math.min(100, p)));
  };

  useEffect(() => {
    const onMove = (e) => { if (!dragRef.current) return; update(e.touches ? e.touches[0].clientX : e.clientX); };
    const stop = () => { dragRef.current = false; };
    window.addEventListener("mousemove", onMove);
    window.addEventListener("touchmove", onMove);
    window.addEventListener("mouseup", stop);
    window.addEventListener("touchend", stop);
    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("touchmove", onMove);
      window.removeEventListener("mouseup", stop);
      window.removeEventListener("touchend", stop);
    };
  }, []);

  const startDrag = (e) => {
    dragRef.current = true;
    update(e.touches ? e.touches[0].clientX : e.clientX);
  };

  return (
    <div
      ref={containerRef}
      data-testid={testId}
      className="relative w-full aspect-[16/10] overflow-hidden select-none border border-[#1F1F1F] cursor-ew-resize bg-[#0A0A0A]"
      onMouseDown={startDrag}
      onTouchStart={startDrag}
    >
      <img src={after} alt="After" className="absolute inset-0 w-full h-full object-cover" />
      <img
        src={before}
        alt="Before"
        className="absolute inset-0 w-full h-full object-cover"
        style={{ clipPath: `polygon(0 0, ${pos}% 0, ${pos}% 100%, 0 100%)` }}
      />
      {/* Divider */}
      <div className="absolute inset-y-0 pointer-events-none" style={{ left: `${pos}%` }}>
        <div className="absolute inset-y-0 -translate-x-1/2 w-[2px] bg-[#C9A96E] shadow-[0_0_12px_rgba(201,169,110,.5)]" />
        <div className="absolute top-1/2 -translate-x-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-[#0A0A0A] border-2 border-[#C9A96E] flex items-center justify-center gold">
          <span className="text-xs">◀▶</span>
        </div>
      </div>
      {/* Labels */}
      <div className="absolute top-4 left-4 mono cream bg-[#0A0A0A]/70 px-3 py-1 border border-[#2A2A2A]">
        {captionBefore}
      </div>
      <div className="absolute top-4 right-4 mono cream bg-[#0A0A0A]/70 px-3 py-1 border border-[#2A2A2A]">
        {captionAfter}
      </div>
    </div>
  );
}
